import { trigger, transition, style, animate } from "@angular/animations";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { LoginService } from "./login.service";
import { Subject, takeUntil } from "rxjs";
import { GlobalService } from "src/app/services/global.service";


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    animations: [
        trigger('slideDownUp', [
            transition(':enter', [
                style({ overflow: 'hidden', opacity: 0 }),
                animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 1 })),
            ]),
            transition(':leave', [
                style({ overflow: 'hidden', opacity: 1 }),
                animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ overflow: 'hidden', opacity: 0 })),
            ]),
        ]),
    ],
    standalone: false
})
export class LoginComponent implements OnInit, OnDestroy{

  bgUrl: string = `${environment.baseHREF}${environment.logo}`;
  //bgUrl: string = `${environment.baseHREF}assets/images/temp/LogoSera.svg`;
  pageBg: string  = `${environment.baseHREF}assets/images/background.svg`;

  // unsubscribe subscription
  private theEnd$ = new Subject<void>();

  showLoginModal: boolean = false;

  constructor(private loginService: LoginService, private global:GlobalService){}
  ngOnInit(): void {
    

    if(this.global.isDark()){
      this.bgUrl = `${environment.baseHREF}${environment.logoDark}`;
    }
  }

  cancel(){
    this.showLoginModal = false;
    //document.getElementById('global-content-container')?.classList.remove('overflow-hidden', 'fixed','w-screen','h-screen' )
  }

  ngOnDestroy(): void {
    this.theEnd$.unsubscribe();
  }


  login(){
    this.cancel();
    this.loginService.loginSubject.next(true);
    
  }



}
